$(document).ready(function() {

  let isMobile = $(window).width() <= 479; // 用于区分是否手机
  let bannerPicSwiperRef = null; // 轮播图Swiper 实例
  let paginationRef = null; // PC分页 DOM对象
  let paginationInstance = null; // PC分页器 实例
  const newsListRef = $('.news-list'); // 新闻列表 DOM
  const noDataRef = $('.news-item-no-data'); // 暂无数据 DOM
  const showMoreBtnRef = $('.mobile-show-more-btn'); // 手机端查看更多按钮 DOM
  const noMoreDataRef = $('.mobile-no-more-data'); // 手机端暂无更多字段 DOM
  let categoryId = ''; // 当前分类id
  let tabActive = 0; // 当前分类index
  let pageNo = 1; // 当前页码
  let pageSize = 10; // 每页显示条数
  let total = 0; // 当前分类列表的总条数
  // let newsList = [];


  // 获取分类Tabs
  function getNewsCategory() {
    try {
      $.get(
        getAjaxUrl() + '/web/News/getNewsCategory', 
        ({ data, errorcode, errormsg }) => {
          if (errorcode === 0) {
            if (data.list.length) {
              const list = data.list.reverse();
              let el = '';
              list.forEach(v => {
                el += (`<li class="tabs-item" data-id="${v.id}">
                  <span class="tabs-item-name text_overflow">${ v.name }</span>
                </li>`);
              })
              $('.tabs-list').append(el)
  
              handleInitTabsClick()
            }
          } else {
            console.log(errormsg);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
  // 获取新闻列表数据
  function getNewsList() {
    return $.post(
      getAjaxUrl() + '/Web/News/getNewsLists', 
      {
        news_category_id: categoryId || '', 
        page_no: pageNo, 
        page_size: pageSize
      },
      ({ data, errorcode, errormsg }) => {
        if (errorcode === 0) {
          total = parseInt(data.count);
          handleNewsList(data.list)
        } else {
          console.log(errormsg);
        }
      }
    );
  }
  // 初始化Tabs点击事件
  function handleInitTabsClick() {
    try {
      const tabsItems = $('.tabs-item');

      tabsItems.each(function (i) {
        this.onclick = () => {
          if (tabActive !== i) {
            tabsItems[tabActive].classList.remove('active')
            this.classList.add('active')
            tabActive = i;
            categoryId = this.dataset.id == 0 ? '' : this.dataset.id;
            pageNo = 1;
            total = 0;

            paginationRef && paginationRef.fadeOut(100);
            showMoreBtnRef.fadeOut(100);
            noMoreDataRef.fadeOut(100);
            newsListRef.fadeOut(100, () => {
              newsListRef.empty();
              getNewsList().then(handleUpdatePagination)
            })
          }
        }
      })
    } catch (error) {
      console.log(error);
    }
  }
  // 准备轮播DOM数据，初始化轮播对象
  function handleInitBannerSwiper(list) {
    try {
      if(list && list.length) {
        const newList = list.slice(0, 6)
        let el = '';
        newList.forEach((v, i) => {
          el += (
            `<li 
              class="banner-picture-item swiper-slide${ i === 0 ? ' active' : '' }"
              data-news-id="${ v.id }"
              data-news-category-id="${ v.news_category_id }">
              <img class="banner-picture" src="${ v.images || 'https://imagecdn.rocketbird.cn/official/image/new/news/swipe-banner-test.png' }" alt="${ v.title }">
              <div class="banner-item-title text_overflow">${ v.title }</div>
            </li>`
          )
        })

        $('.banner-picture-list').html(el)
        bannerPicSwiperRef = new Swiper ('.news-banner-wrapper', {
          loop: true, // 循环模式选项
          autoplay: {
            delay: 5 * 1000, 
          },
          speed: 300,
          grabCursor: true,
          touchRatio: 0.4, // 触摸距离与slide滑动距离的比率, 默认1
          // 如果需要前进后退按钮
          navigation: isMobile ? {} : {
            nextEl: '.news-swiper-button-next',
            prevEl: '.news-swiper-button-prev',
          },
          // 如果需要分页器
          pagination: {
            el: '.swiper-pagination',
            /* 自定义分页器按钮样式 */
            // type : 'custom',
            bulletElement : 'div',
            bulletClass: 'news-pagination-btn',
            bulletActiveClass: 'active',
            currentClass: 'active',
            clickable: true,
          },
          // on: {
          //   click: function(swiper, event) {
          //     alert('你点了Swiper');
          //   },
          // },
        })
        // $('.news-banner-wrapper').addClass('hover')

        $('.banner-picture-item').each(function () {
          this.addEventListener('click', () => {
            const { newsCategoryId, newsId } = this.dataset;
            window.location.href = `./news_detail.html?c=${newsCategoryId}&i=${newsId}`;
          })
        })
        
      } else {
        if (bannerPicSwiperRef) {
          bannerPicSwiperRef.destroy(true, true)
          $('.banner-picture-list').html(
            (`<li class="banner-picture-item swiper-slide active">
              <img class="banner-picture" src="https://imagecdn.rocketbird.cn/official/image/new/news/swipe-banner-test.png">
              <div class="banner-item-title text_overflow">勤鸟新闻</div>
            </li>` )
          )
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 准备新闻列表DOM
  function handleNewsListDOM(list) {
    try {
      let el = '';
      const detailNum = isMobile ? 28 : 33;
  
      list.forEach(v => {
        // let title = v.title.substring(0, 48) + (v.title.length > 48 ? '…' : ''), // title 1 24  2 48
        // href = `./news_detail.html?c=${v.news_category_id}&i=${v.id}`;
        // let detail = v.details.replace(/<[^>]+>/g, '').substring(0, detailNum * (title.length <= 25 ? 3 : 2)) + '……'; // detail 1 27
        let title = v.title,
        href = `./news_detail.html?c=${v.news_category_id}&i=${v.id}`,
        detail = v.details.replace(/<[^>]+>/g, '').substring(0, detailNum * 3) + '…';

        let [years, month, day] = v.create_time.split('-');
        month = month.padStart(2, 0);
        day = day.padStart(2, 0);
        const date = `${years}年${month}月${day}日`
        
        el += (
          `<li class="news-item clearfix">
            <a class="news-item-poster-link" href="${ href }">
              <img
                class="news-item-poster-img"
                src="${ v.images || 'https://imagecdn.rocketbird.cn/official/image/new/news/swipe-banner-test.png' }"
                alt="${ v.title }">
            </a>
            <h2 class="news-item-title text_overflow">
              <a href="${ href }">${ title }</a>
            </h2>
            <div class="news-item-desc">
              <p>${ detail }</p>
            </div>
            <div class="news-item-date-box">
              <div class="news-item-date">${ month + '.' + day }</div>
              <div class="news-item-years">${ years }</div>
              <img
                class="news-item-mobile-icon" 
                src="https://imagecdn.rocketbird.cn/official/image/new/news/news-date-icon.png" />
              <span class="news-item-mobile-date">${ date }</span>
            </div>
          </li>`
        )
      })
      return el;
    } catch (error) {
      console.log(error);
    }
  }
  // 处理新闻列表
  function handleNewsList(list) {
    if(list && list.length) {
      if (isMobile) { // TODO  先判断移动
        const el = handleNewsListDOM(list)
        newsListRef.append(el)

        if (pageNo * pageSize < total) {
          showMoreBtnRef.fadeIn(100);
        } else {
          showMoreBtnRef.hide();
          noMoreDataRef.fadeIn(100);
        }
      } else {
        const el = handleNewsListDOM(list)
        newsListRef.html(el)
      }

      noDataRef.hide();
      newsListRef.fadeIn(100)
      paginationRef && paginationRef.fadeIn(100);
    } else {
      newsListRef.fadeOut(100, () => {
        noDataRef.fadeIn(100);
        newsListRef.empty();
      })
    }
  }
  // 初始化分页对象
  function handleInitPagination(pageCount) {
    try {
      paginationRef = $('.pagination').pagination({
        pageCount: pageCount || 0, // 总页数
        // showData: 10, // 每页显示的条数
        // totalData: 0,  // 数据总条数
        current: 1, // 当前第几页
        prevCls: 'prev', // 上一页class
        nextCls: 'next', // 下一页class
        prevContent: '<', // 上一页节点内容
        nextContent: '>', // 下一页节点内容
        activeCls: 'active', // 当前页选中状态class名
        count: 2, // 当前选中页前后页数
        coping: true, // 是否开启首页和末页，值为boolean
        // homePage: '', // 首页节点内容，默认为空
        // endPage: '', // 尾页节点内容，默认为空
        // jump: false, // 是否开启跳转到指定页数，值为boolean类型
        // jumpIptCls: 'jump-ipt', // 文本框内容
        // jumpBtnCls: 'jump-btn', // 跳转按钮class
        // jumpBtn: '跳转', // 跳转按钮文本内容
        callback: (instance) => { // 回调函数，参数"index"为当前页
          console.log(instance.getCurrent());
          handleChangePage(instance)
        } 
      }, function (instance) {
        paginationInstance = instance;
        // console.log('get', api.getCurrent());
        // console.log('get', api.getTotalPage());
      })
    } catch (error) {
      console.log(error);
    }
  }
  // 更新分页对象参数
  function handleUpdatePagination() {
    // console.log(paginationRef);
    // console.log(paginationInstance);
    try {
      if (isMobile) {
        
      } else {
        const pageCount = Math.ceil(parseInt(total) / pageSize)
        paginationInstance.setTotalPage(pageCount)
        paginationInstance.init()
      }
     
    } catch (error) {
      console.log(error);
    }
  }
  // 处理页码改变
  function handleChangePage(instance) {
    try {
      pageNo = instance.getCurrent();
      getNewsList()
    } catch (error) {
      console.log(error);
    }
  }


  if (isMobile) {
    showMoreBtnRef[0].onclick = () => {
      try {
        if(pageNo * pageSize < total) {
          pageNo += 1;
          getNewsList();
        }
      } catch (error) {
        console.log(error);
      }
    }
  } else {
    /* 列表分页 */
    handleInitPagination()
  }

  getNewsCategory();
  getNewsList().then(({ data }) => {
    // handleInitBannerSwiper(data.list) 因为目前新闻首图尺寸和轮播图设计尺寸差距略大，轮播图显示图片不全，暂时不显示轮播图栏
    handleUpdatePagination()
  })

});
